import { BodyText } from "@/components/ui/Text";
import type { ChatMessage } from "../../types/chatMessageTypes";

interface AutochatFailureMessageProps {
  message: ChatMessage;
}

export const AutochatFailureMessage = ({
  message,
}: AutochatFailureMessageProps) => {
  return (
    <div className="flex flex-col gap-2 justify-center items-center">
      <BodyText size="xs" textColor="primary" italic>
        {message.text}
      </BodyText>
    </div>
  );
};
